
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedReviews from './components/FeaturedReviews';
// import AuthorSpotlight from './components/AuthorSpotlight';
import NewsletterSignup from './components/NewsletterSignup';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <FeaturedReviews />
        {/* <AuthorSpotlight /> */}
        <NewsletterSignup />
      </main>
      <Footer />
    </div>
  );
}
